import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { i18nResources } from 'i18n'
import { SupportedLocale } from 'shared'

void i18n.use(initReactI18next).init({
  resources: i18nResources,
  fallbackLng: SupportedLocale.EN,
  supportedLngs: [SupportedLocale.EN, 'es', SupportedLocale.ES_MX],
  nonExplicitSupportedLngs: true,
  interpolation: { escapeValue: false },
})

export default i18n
